import { OfferLabel as StyledOfferLabel } from './OfferLabel.styled';

const OFFER_TYPE_CONFIG: Record<
  number,
  { backgroundColor: string; text: string; textColor: string }
> = {
  0: {
    backgroundColor: '#FADB14',
    text: 'Estq no prod. (ENP)',
    textColor: '#000000',
  },
  1: {
    backgroundColor: '#389E0D',
    text: 'Recepcionado (LKP)',
    textColor: '#ffffff',
  },
  2: {
    backgroundColor: '#13C2C2',
    text: 'No sítio (LKP)',
    textColor: '#ffffff',
  },
  3: {
    backgroundColor: '#F78E1E',
    text: 'Oferta Direcionada (ENP)',
    textColor: '#ffffff',
  },
  4: {
    backgroundColor: '#F5222D',
    text: 'Oft. Exclusiva (ENP)',
    textColor: '#ffffff',
  },
} as const;

const DEFAULT_OFFER_CONFIG = {
  backgroundColor: '#e67e22',
  text: 'LEILÃO',
  textColor: '#ffffff',
} as const;

export interface OfferLabelProps {
  offerType: number;
  upperText?: boolean;
}

const getOfferConfig = (offerType: number) =>
  OFFER_TYPE_CONFIG[offerType] || DEFAULT_OFFER_CONFIG;

export function OfferLabel({ offerType, upperText = true }: OfferLabelProps) {
  const { backgroundColor, text, textColor } = getOfferConfig(offerType);

  return (
    <StyledOfferLabel
      backgroundColor={backgroundColor}
      textColor={textColor}
      className="offer-label"
    >
      {upperText ? text.toUpperCase() : text}
    </StyledOfferLabel>
  );
}
